import React from 'react';
import { painPoints } from '../../data/curly';
import { panelStyle } from '../../utils/imagePanel';
export function PainSection() {
  return <section className="border-b border-white/5 bg-cocoa py-20" aria-labelledby="pain-title" data-id="element-111" data-mp="2n2qjel5rm7i2">
      <div className="mx-auto grid w-full max-w-6xl gap-12 px-6 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:gap-16" data-id="element-112" data-mp="2s0079wdiab3s">
        <div className="h-72 w-full rounded-lg border border-white/10 lg:h-[26rem]" style={panelStyle(2)} role="img" aria-label="Cabello encrespado a la izquierda y rizo definido a la derecha" data-id="element-113" data-mp="2w1264c3igl58" />

        <div data-id="element-114" data-mp="3arswrgtd9e6r">
          <h2 id="pain-title" className="font-display text-3xl text-cream sm:text-4xl" data-id="element-115" data-mp="3at441qm0t42m">
            No es tu cabello. Es el orden en que lo estás tratando.
          </h2>
          <p className="mt-4 max-w-prose text-sand" data-id="element-116" data-mp="3jt993u3qrqdm">
            El rizo no se arregla comprando más. Se arregla entendiendo qué le falta —agua, proteína
            o simplemente menos producto— y en qué momento dárselo.
          </p>

          <ul className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-117" data-mp="4gevh5ttp5w4">
            {painPoints.map(point => <li key={point} className="flex gap-4 py-4 text-cream" data-id="element-118" data-mp="g4pht616fh9">
                <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" data-id="element-119" data-mp="3rl4fr5j6h87z" />
                <span className="leading-relaxed" data-id="element-120" data-mp="3mmt4qrh5cro6">{point}</span>
              </li>)}
          </ul>

          <p className="mt-8 font-display text-2xl italic text-gold-soft" data-id="element-121" data-mp="o2t8ki6s0dzg">
            Si reconociste tres o más, este método se escribió para ti.
          </p>
        </div>
      </div>
    </section>;
}